import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { history } from '../../../store';
import classNames from 'classnames';
import { updateApplication } from '../../../actions/applications';
import { getRoute, loading } from '../../../actions/sessions';
import { asyncActions } from '../../../actions/general';
import useRouteStatus from '../../../hooks/useRouteStatus';
import useValidateRoute from '../../../hooks/useValidateRoute';
import useSessionEntity from '../../../hooks/useSessionEntity';
import Error from '../../shared/Error';
import Heap from '../../../lib/heap';

const heap = new Heap();

export default function Ownership({location}) {
  const dispatch = useDispatch();
  const [owner, isOwner] = useState(true);

  const isLoading = useSelector(state => state.sessions.get('loading'));
  const application = useSessionEntity('application');
  const user = useSessionEntity('user');
  const merchant = useSessionEntity('merchant');

  useRouteStatus(location);

  useEffect(() => {
    if (user) heap.identify(user.email);
  }, [application, merchant]);

  const save = () => {
    dispatch(loading(true));

    dispatch(asyncActions(
      updateApplication(application.set('is_authorized_signer', owner)),
      owner && getRoute()
    ))
    .then(() => !owner && history.push('/apply/notify_owner'))
    .then(() => dispatch(loading(false)));
  }

  if (!useValidateRoute({ apply: true, company: true })) return (<></>);

  return (
    <div id="content">
      <div className="is-size-4 has-text-weight-semibold mb-5">Are you an owner of <span style={{ whiteSpace: 'nowrap' }}>{application.company_name}</span>?</div>

      <Error />

      <div className="mb-6">
        <div className="field">
          <input type="radio" className="is-checkradio" id="is_authorized_signer" name="is_authorized_signer" onChange={() => isOwner(true)} value={owner} checked={owner} />
          <label htmlFor="is_authorized_signer">I'm an owner and authorized to sign on behalf of <span style={{ whiteSpace: 'nowrap' }}>{application.company_name}</span></label>
        </div>

        <div className="field">
          <input type="radio" className="is-checkradio" id="is_not_authorized_signer" name="is_authorized_signer" onChange={() => isOwner(false)} value={owner} checked={!owner} />
          <label htmlFor="is_not_authorized_signer">I need quick approval from a business owner</label>
        </div>
      </div>

      <button
        type="submit"
        role="submit"
        disabled={isLoading}
        className={classNames('button is-primary is-large is-fullwidth has-text-weight-bold', {
          'is-loading': isLoading
        })}
        onClick={save}>
          Next
      </button>
    </div>
  )
}
